import { Card } from "shared/ui/cards/modalCard"
import { Container, RadioIcon } from "../styles"
import { Status } from "./Status"
import { Flex } from "shared/ui/flex"
import { TextCard } from "shared/ui/cards/textCard"
import { TextareaField } from "shared/ui/Inputs/textarea/styles"
import { FC, useEffect, useState } from "react"
import { Deposit } from "entities/orders/model/types"
import { Checkbox } from "shared/ui/checkbox"

interface BookingDepositeInfoProps {
  deposit?: Deposit | null;
}

export const BookingDepositeInfo: FC<BookingDepositeInfoProps> = ({
  deposit,
}) => {
  
  const [ info, setInfo ] = useState<any>({
    amount: 0,
    date: '',
    dt_paid: false,
    comment: '',
  });

  useEffect(() => {
    const obj: any = {}
    
    if (deposit?.amount) {
      const amount = typeof deposit?.amount === 'string' ? parseFloat(deposit?.amount).toLocaleString('ru-RU') : deposit?.amount.toLocaleString('ru-RU');
      obj.amount = amount
    }
    if (deposit?.due_date) {
      const dueDate = deposit?.due_date;
      const dateStr = new Date(dueDate).toLocaleDateString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
      })
      obj.date = dateStr;
    }
    if (deposit?.dt_paid) {
      obj.dt_paid = deposit?.dt_paid;
    }
    if (deposit?.comment) {
      obj.comment = deposit?.comment;
    }
    if (deposit?.provider?.backend?.icon) {
      obj.icon = deposit?.provider.backend.icon
    }
    if (deposit?.status) {
      obj.status = deposit?.status
    }

    setInfo(obj);
  }, [deposit])

  if (!deposit) return <></>;

  return (
    <Container>
      <Card
        headerContent="Депозит"
        indentsCard={false}
        styles={{
          padding: '8px 12px',
          header: { height: '24px', padding: '8px 16px' },
          cardVariant: 'secondary',
        }}
        buttons={info?.status ? [
          <Status 
            status={info.status}
            tooltipText={null}
            key={0}
          />
        ] : []}
      >
        <Flex
          $direction='column'
          $gap='12px'
          $margin="0 0 4px 0"
        >
            <Flex
              $gap='12px'
              $alignItems='center'
            >
              <Flex
                $gap='2px'
                $alignItems='center'
              >
                <TextCard 
                  mode='small'
                >{info.amount}</TextCard>
                <RadioIcon src={info.icon} />
              </Flex>
            </Flex>
          <Flex
            $alignItems="center"
            $justify="space-between"
          >
            <span>Оплатить до: {info.date}</span>
            {(info.dt_paid) ? 
              <Checkbox
                direction="row-reverse"
                gap="3px"
                onChange={()=>{null}}
                isChecked={true}
                mode="small"
              >
                Оплачено
              </Checkbox>
              : <></>
            }
          </Flex>
          {(info.comment?.trim()) && 
            <TextareaField
              placeholder='Комментарий к депозиту ...'
              value={info.comment}
              onChange={()=>null}

              $height={`100px`}
              $width='96%'
            />
          }
        </Flex>
      </Card>
    </Container>
  )
}